// Production
export const API_BASE_URL = "https://aktiennewsreader.azurewebsites.net";
